import { z } from 'zod';

export const SetupTransactionSecuritySchema = z.object({
  transaction_password: z.string().min(6).max(128),
  security_question: z.string().min(1).max(256),
  security_answer: z.string().min(1).max(256),
});

export type SetupTransactionSecurityRequest = z.infer<typeof SetupTransactionSecuritySchema>;

export const VerifyTransactionSecuritySchema = z.object({
  transaction_password: z.string().min(1).max(128),
  security_answer: z.string().min(1).max(256),
});

export type VerifyTransactionSecurityRequest = z.infer<typeof VerifyTransactionSecuritySchema>;
